import { useLocation as gatsbyLocation } from '@gatsbyjs/reach-router';

const REPLACEMENT_KEYS = ['firstName', 'lastName', 'donationAmount', 'emailAddress'];

const FALLBACK_TEXT = {
  firstName: 'friend',
  lastName: '',
  donationAmount: 'a donation',
  emailAddress: '',
};

export const replaceStringWithLocationState = (text: string = null): string | null => {
  const location = gatsbyLocation();

  // Return  if no text string is provided
  if (!text) {
    return null;
  }

  if (!location.state) {
    return text;
  }

  let replacedText = text;

  REPLACEMENT_KEYS.forEach(key => {
    const regex = new RegExp(`%${key}`, 'g');
    const locationStateValue = location?.state[key];

    if (regex.test(replacedText) && !locationStateValue) {
      replacedText = replacedText.replace(regex, FALLBACK_TEXT[key]);
      return;
    }
    replacedText = replacedText.replace(regex, locationStateValue);
  });

  return replacedText;
};
